import axios from "axios";
import Oidc from "oidc-client";
import { lstat } from "fs";
import moment from "moment";

export default {
  name: "ApiServiceMixin",
  data() {
    return {
      loggedInUser: "Guest",
      loggedInCompany: "",
      axios: axios,
      companyClass: "upesi",
      groups: [],
      users: [],
      aCompanyUsers: [],
      permissions: [],
      groupUsers: [],
      userPemissions: [],
      countries: [],
      collectionmodes: [],
      currencies: [],
      serviceTypes: [],
      bridgeBanks: [],
      bridgeBankBranches: [],
      remittancePurpose: [],
      countryCurrencies: [],
      bridgebank: [],
      fundingTypes: [],
      companyNames: [],
      selectedCompanyId: "",
      countryServices: [],
      documentTypes: [],
      senderdocumentTypes: [],
      receiverdocumentTypes: [],
      ruleTypes: [],
      CustomerProfilePicture: "",
      IdProfile: "",
      IdBackProfile: "",
      wrkPermit: "",
      specialPass: "",
      ruleTriggers: [],
      ruleFrequency: [],
      ledgerAccounts: [],
      transactionsPageInfo: { total: 1 },
      documentTypesPageInfo: { total: 1 },
      companyPartnerTransactionsPageInfo: { total: 1 },
      transfastCountries: [],
      transfastStates: [],
      transfastCities: [],
      transfastReceiverIdTypes: [],
      transfastRemittanceReasons: [],
      transfastReceiverOccupations: [],
      companyRegions: [],
      countryMobileProviders: [],
      principalCompanies: [],
      nationalities: [],
      sub: "",
      mgr: this.$mngr,
      imagePlaceholder:
        "data:image/jpeg;base64,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",
    };
  },
  created() {
    this.getUserName();
  },
  methods: {
    setAuthHeader() {
      return new Promise((resolve, reject) => {
        let self = this;
        self.mgr
          .getUser()
          .then(function (user) {
            if (user && !user.expired) {
              self.axios.defaults.headers.common.Authorization =
                "Bearer " + user.access_token;
              self.axios.defaults.headers.common.Accept = "application/json";
              self.axios.defaults.headers.common[
                "Access-Control-Allow-Origin"
              ] = "*";
              self.axios.defaults.headers.common["Content-Type"] =
                "application/json";

              self.sub = user.profile.sub;
              resolve(self.axios);
            } else {
              self.mgr.signinRedirect();
            }
          })
          .catch((error) => reject(error));
      });
    },
    setAuthHeaderForMultipart() {
      return new Promise((resolve, reject) => {
        let self = this;
        self.mgr
          .getUser()
          .then(function (user) {
            if (user && !user.expired) {
              self.axios.defaults.headers.common.Authorization =
                "Bearer " + user.access_token;
              self.axios.defaults.headers.common.Accept = "multipart/form-data";
              self.axios.defaults.headers.common[
                "Access-Control-Allow-Origin"
              ] = "*";
              self.axios.defaults.headers.common["Content-Type"] =
                "multipart/form-data";

              self.sub = user.profile.sub;
              resolve(self.axios);
            } else {
              self.mgr.signinRedirect();
            }
          })
          .catch((error) => reject(error));
      });
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    logoutCurrentUser() {
      this.mgr
        .signoutRedirect()
        .then(function (resp) {
          console.log("signed out", resp);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getNationalities() {
      return new Promise((resolve, reject) => {
        let self = this;
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetNationalities")
              .then((response) => {
                self.nationalities = response.data;
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getGroups() {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          client
            .get(self.$base_ApiK_Url + "SLAAuthorization/getgroups")
            .then((response) => (self.groups = response.data))
            .catch((error) => console.log(error));
        })
        .catch((error) => console.log(error));
    },
    saveGroup(groupdata) {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          client
            .post(self.$base_ApiK_Url + "SLAAuthorization/SaveGroup", groupdata)
            .then(() => self.getGroups())
            .catch((error) => console.log(error));
        })
        .catch((error) => console.log(error));
    },
    deleteGroup(id) {
      let self = this;
      this.setAuthHeader().then((client) => {
        client
          .delete(self.$base_ApiK_Url + "SLAAuthorization/DeleteGroup/" + id)
          .then(() => self.getGroups())
          .catch((err) => console.log(err));
      });
    },
    getUsers(companyID) {
      let self = this;
      let selCompanyId = "";
      if (companyID) {
        selCompanyId = companyID;
      }
      this.setAuthHeader()
        .then((client) => {
          client
            .get(
              `${self.$base_ApiK_Url}SLAAuthorization/GetMTSUsers/${selCompanyId}`
            )
            .then((response) => (self.users = response.data))
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    },

    getUsersProfiles() {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          client
            .get(self.$base_ApiK_Url + "SLAAuthorization/getusersprofiles")
            .then((response) => (self.users = response.data))
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    },
    getAllMpesaTransactions() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/GetMpesaTransactions`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getAllBankTransactions() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/GetBankTransactions`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getUserInfoAccessLogs() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/GetUserInfoAccessLogs`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getAllCustomerProfiles() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}SLAAuthorization/GetCustomers`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getWebappConfirmedUsers() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Customers/GetConfirmedUsers/`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getWebappUsers() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}SLAAuthorization/getusers/`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getUserKYCProfile(userId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}SLAAuthorization/GetKYCUserProfile/` +
                  userId
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },

    getCustomerPicture(selectedUserId) {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          client
            .get(
              self.$base_ApiK_Url +
                "Utility/GetProfilePicture/" +
                selectedUserId
            )
            .then((response) => {
              if (response.status == "200") {
                self.CustomerProfilePicture =
                  "data:image/png;base64," + response.data;
              }
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    },

    getIdPicture(selectedUserId) {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          client
            .get(self.$base_ApiK_Url + "Utility/getidpicture/" + selectedUserId)
            .then((response) => {
              if (response.status == "200") {
                self.IdProfile = "data:image/png;base64," + response.data;
              }
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    },
    getBackIdPicture(selectedUserId) {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          client
            .get(self.$base_ApiK_Url + "Utility/GetIdBackImg/" + selectedUserId)
            .then((response) => {
              if (response.status == "200") {
                self.IdBackProfile = "data:image/png;base64," + response.data;
              }
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    },
    // mbuvi
    getWorkPermitPicture(selectedUserId) {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          client
            .get(
              self.$base_ApiK_Url + "Utility/GetWorkpermitImg/" + selectedUserId
            )
            .then((response) => {
              if (response.status == "200") {
                self.wrkPermit = "data:image/png;base64," + response.data;
              }
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    },

    getSpecialpassPicture(selectedUserId) {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          client
            .get(
              self.$base_ApiK_Url +
                "Utility/GetSpecialPassImg/" +
                selectedUserId
            )
            .then((response) => {
              if (response.status == "200") {
                self.specialPass = "data:image/png;base64," + response.data;
              }
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    },
    redownloadMetaMapKYCDocuments(userId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Customers/ReDownloadKYCDocuments/` +
                  userId
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getIndividualKYCDocuments(userId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Customers/GetIndividualKYCDocuments/` +
                  userId
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getAllCustomerTransactions(userID) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Transactions/GetUserTransactions/` +
                  userID
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    saveUser(userdata) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var userInfo = Object.assign({ createdBy: self.sub }, userdata);

            client
              .post(self.$baseUrl + "users/CreateBOUser", userInfo)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    updateBOUser(userdata) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var userInfo = Object.assign({ createdBy: self.sub }, userdata);

            client
              .post(self.$baseUrl + "users/UpdateBOUser", userInfo)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    createUser(userdata) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var userInfo = Object.assign({ createdBy: self.sub }, userdata);
            client
              .post(self.$baseUrl + "users/CreateUser", userInfo)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },

    GetCashPickupLocations(countryId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Utility/GetCashPickupLocations/` +
                  countryId
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    uploadCompanyKycDocument(companyDocument) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeaderForMultipart()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Customers/SaveCompanyKYCDocuments`,
                companyDocument
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getCompanyKycDocuments(userId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Customers/GetCompanyKYCDocuments/` +
                  userId
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },

    uploadUserProfilePicture(userPicture) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeaderForMultipart()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Customers/SaveUserProfilePicture`,
                userPicture
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    uploadKycDocument(userDocument) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeaderForMultipart()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `SLAAuthorization/SaveUserID`,
                userDocument
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    uploadTransactionDocument(userDocument) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeaderForMultipart()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  `Transactions/AddTransactionSupportDocument`,
                userDocument
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getTransactionDocument(Id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Transactions/GetTransactionDocument/` +
                  Id
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getLogedInUserEmail() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client

              .get(
                `${self.$base_ApiK_Url}SLAAuthorization/GetLoggedInUserEmail`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },

    activateUser(id, lockout) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$baseUrl + "users/ActivateUser/" + id + "/" + lockout)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject.log(err));
          })
          .catch((err) => reject.log(err));
      });
    },

    deleteUserKYC(userID) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  "SLAAuthorization/DeleteKycUserProfile/" +
                  userID
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject.log(err));
          })
          .catch((err) => reject.log(err));
      });
    },
    disapproveUser(userID, failureReason) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  "SLAAuthorization/DisApproveUserProfiles/" +
                  userID +
                  "/" +
                  failureReason
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject.log(err));
          })
          .catch((err) => reject.log(err));
      });
    },

    approveUser(userID, KycComments, expiryDate, failureReason) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  "SLAAuthorization/ApproveUserProfiles/" +
                  userID +
                  "/" +
                  KycComments +
                  "/" +
                  expiryDate +
                  "/" +
                  failureReason
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject.log(err));
          })
          .catch((err) => reject.log(err));
      });
    },

    reSendConfirmationEmail(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$baseUrl + `users/ReSendConfirmationEmail/${id}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    lockAccount(id, lockout) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$baseUrl + `users/LockAccount/${id}/${lockout}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getGroupPermissions(groupId) {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          client
            .get(
              self.$base_ApiK_Url +
                "SLAAuthorization/GetGroupPermissions/" +
                groupId
            )
            .then((response) => (self.permissions = response.data))
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    },
    getGroupUsers() {
      let self = this;
      self.groupUsers = [];

      return new Promise((resolve, reject) => {
        this.setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  "SLAAuthorization/GetMTSUsers/" +
                  this.selectedCompanyId
              )
              .then((response) => {
                for (var ug of response.data) {
                  self.groupUsers.push({
                    id: ug.id,
                    selected: false,
                    firstName: ug.firstName,
                    lastName: ug.lastName,
                    phoneNumber: ug.phoneNumber,
                    email: ug.email,
                  });
                }
                resolve(true);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getUserGroups(groupId) {
      let self = this;

      for (var u of self.groupUsers) {
        u.selected = false;
      }

      this.setAuthHeader()
        .then((client) => {
          client
            .get(
              self.$base_ApiK_Url + "SLAAuthorization/GetGroupUsers/" + groupId
            )
            .then((response) => {
              for (var ug of response.data) {
                for (var u of self.groupUsers) {
                  if (u.id == ug.userID) {
                    u.selected = true;
                  }
                }
              }
            })
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    },
    saveGroupPermissions(groupId) {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          client
            .post(
              self.$base_ApiK_Url +
                `SLAAuthorization/SaveGroupPermissions/${groupId}`,
              self.permissions
            )
            .then((response) => (self.permissions = response.data))
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    },
    saveGroupUsers(groupId) {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          var uGroups = [];

          for (var ug of self.groupUsers) {
            uGroups.push({
              ID: ug.id,
              Selected: ug.selected,
              GroupID: groupId,
            });
          }

          client
            .post(
              self.$base_ApiK_Url + "SLAAuthorization/SaveGroupUsers/",
              uGroups
            )
            .then((response) => (self.permissions = response.data))
            .catch((err) => console.log(err));
        })
        .catch((err) => console.log(err));
    },
    getUserPermissions() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  "SLAAuthorization/GetUserPermissions/" +
                  self.sub
              )
              .then((response) => {
                self.userPemissions = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },

    //UTILITY
    async getLoggedInCompany() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetLoggedInCompany/")
              .then((response) => {
                self.loggedInCompany = response.data;
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getReceiverDocumentTypes(doctypesData) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Utility/GetReceiverDocumentTypes`,
                doctypesData
              )
              .then((response) => {
                self.receiverdocumentTypes = response.data;
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getDocumentTypesByCountryId(customerType, countryId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            //var cType = customerType === 1 ? "Individual" : "Company";
            client
              .get(
                self.$base_ApiK_Url +
                  `Utility/GetDocumentTypes/${customerType}/${countryId}`
              )
              .then((response) => {
                self.documentTypes = response.data;
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getSenderDocumentTypes(doctypesData) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Utility/GetSenderDocumentTypes`,
                doctypesData
              )
              .then((response) => {
                self.senderdocumentTypes = response.data;
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getMobileProvidersByCountryId(countryId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Utility/GetMobileProviders/${countryId}`
              )
              .then((response) => {
                self.countryMobileProviders = response.data;
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getBanksCountryId(countryId, paymentService) {
      let self = this;
      // if (countryId == '142') {
      //   return Promise.resolve();
      // }

      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Utility/GetBridgeBanks/${countryId}/${paymentService}`
              )
              .then((response) => {
                self.bridgeBanks = Object.freeze(response.data);
                resolve(self.bridgeBanks);
              })
              .catch((err) => {
                //console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            //console.log(err);
            reject(err);
          });
      });
    },
    getBankBranches(countryId, bankCode, paymentService) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Utility/GetBridgeBankBranches/${countryId}/${bankCode}/${paymentService}`
              )
              .then((response) => {
                self.bridgeBankBranches = Object.freeze(response.data);
                resolve(self.bridgeBankBranches);
              })
              .catch((err) => {
                //console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            //console.log(err);
            reject(err);
          });
      });
    },
    getTerrapayBanksCountryId(searchbanks) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_ApiK_Url + `Utility/SearchBanks`, searchbanks)
              .then((response) => {
                self.bridgeBanks = Object.freeze(response.data);
                console.log(self.bridgeBanks);
                resolve(Object.freeze(response.data));
              })
              .catch((err) => {
                //console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            //console.log(err);
            reject(err);
          });
      });
    },
    GetBridgeBankDetails(bankid) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Utility/GetBridgeBankDetails/${bankid}`
              )
              .then((response) => {
                self.bridgeBank = response.data;
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getEMQCountries() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "BPS/getEMQCountries")
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },

    getCountries() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetCountries/")
              .then((response) => {
                self.countries = response.data;
                //alert("contries: "+JSON.stringify(response.data))
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getStates(countryId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Utility/GetStates/${countryId}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getCities(countryId, stateCode) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Utility/GetCities/${countryId}/${stateCode}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getUremitSendStatus(countryId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Utility/getUremitSendStatus/${countryId}`
              )
              .then((response) => {
                self.countries = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },

    getCurrencies() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetCurrencies/")
              .then((response) => {
                self.currencies = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getCurrenciesbyCountryId(countryId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Utility/GetAvailableCurrencies/${countryId}`
              )
              .then((response) => {
                self.countryCurrencies = response.data;
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getServices() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetServiceTypes/")
              .then((response) => {
                self.serviceTypes = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },

    getBridgeBanks() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetBridgeBanks/")
              .then((response) => {
                self.bridgeBanks = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },

    getFundingTypes() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetFundingTypes/")
              .then((response) => {
                self.fundingTypes = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getRuleTypes() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetTransactionRuleTypes/")
              .then((response) => {
                self.ruleTypes = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getRuleTriggers() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetTransactionRuleTriggers/")
              .then((response) => {
                self.ruleTriggers = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getRuleFrequency() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetTransactionRuleFrequency/")
              .then((response) => {
                self.ruleFrequency = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getAvailableCurrencies() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetAvailableCurrencies/")
              .then((response) => {
                self.currencies = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getCompanyCurrencies() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetCompanyCurrencies/")
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getUserOperationalCountries() {
      return new Promise((resolve, reject) => {
        let self = this;
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetUserOperationalCountries")
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getOperationalCountries() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetOperationalCountries/")
              .then((response) => {
                self.companyRegions = response.data;
                // alert("Opertn countries: Count::: "+self.companyRegions.length+" List "+JSON.stringify(self.companyRegions) )
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getOperationalCountriesData(countryId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Utility/GetOperationalCountriesData/${countryId}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getAdditionalInfo(fromCountryId, toCountryId, customerType) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Settings/GetAdditionalInfo/${fromCountryId}/${toCountryId}/${customerType}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },

    getRuleFrequencies() {
      let self = this;
      return new Promise((resolve, reject) => {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetRuleFrequency")
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getDOW() {
      let self = this;
      return new Promise((resolve, reject) => {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetDOW")
              .then((result) => resolve(result.data))
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getQuaters() {
      let self = this;
      return new Promise((resolve, reject) => {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetQuaters")
              .then((result) => resolve(result.data))
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
    getMonths() {
      let self = this;
      return new Promise((resolve, reject) => {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Utility/GetMonths")
              .then((result) => resolve(result.data))
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },

    //COMPANIES GetCompanyCurrency
    saveCompany(company) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var _ep =
              company.id > 0
                ? "Companies/UpdateCompany/"
                : "Companies/CreateCompany/";
            client
              .post(self.$base_ApiK_Url + _ep, company)
              .then((result) => {
                resolve(result.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getCompanies(search) {
      var parsedobj = JSON.parse(JSON.stringify(search));
      console.log(parsedobj);
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var searchQuery = "";
            if (search) {
              searchQuery = "?CompanyType=" + search.CompanyType;
            }
            client
              .post(`${self.$base_ApiK_Url}Companies/GetCompanies`, search)
              //.get(`${self.$base_ApiK_Url}Companies/GetCompanies/${page}/${size}${searchQuery}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getPartnerTransactions(
      loggedInCompany,
      search = "0",
      partner = "0",
      fromdate = "",
      todate = ""
    ) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Reports/getpartnertransactionsreport/${loggedInCompany}/${search}/${partner}/${fromdate}/${todate}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getNewCustomers(fromdate, todate, preApproved) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Reports/getNewCustomersReport/${fromdate}/${todate}/${preApproved}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getMTSUserPermissions(companyID) {
      let self = this;
      let cmpID = "";
      if (companyID) {
        cmpID = companyID;
      }
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}SLAAuthorization/getMTSUserPermissions/${cmpID}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getUserTransactionsSummary(fromdate, todate) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Reports/getUserTransactionsSummaryReport/${fromdate}/${todate}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getCustomers(search) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/getCustomersReport/${search}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },

    getLedgerAccountCurrency(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Companies/GetLedgerAccountCurrency/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getCompanyCurrency(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Companies/GetCompanyCurrency/${id}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getPricipalCompanies(countryId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Companies/GetPricipalCompanies/${countryId}`
              )
              .then((response) => {
                self.principalCompanies = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    // getEMQCompanyNames() {
    //   let self = this;
    //   return new Promise(function (resolve, reject) {
    //     self
    //       .setAuthHeader()
    //       .then((client) => {
    //         client
    //           .get(self.$base_ApiK_Url + "BPS/getEMQCountries")
    //           .then((response) => {
    //             self.companyNames = response.data;
    //             resolve(response.data);
    //           })
    //           .catch((err) => reject(err));
    //       })
    //       .catch((err) => reject(err));
    //   });
    // },
    getCompanyNames() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Companies/GetCompanyNames/")
              .then((response) => {
                self.companyNames = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getCompanyPartnerNames() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Companies/GetCompanyPartnerNames/")
              .then((response) => {
                self.companyNames = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    deleteCompany(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .delete(self.$base_ApiK_Url + "Companies/DeleteCompany/" + id)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteCompanies(selectedCompanies) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + "Companies/DeleteCompanies/",
                selectedCompanies
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getCompanyNamesByServiceType(countryId, serviceType) {
      let self = this;
      this.companyNames = [];
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Companies/GetCompanyNamesByServiceType/${countryId}/${serviceType}`
              )
              .then((response) => {
                self.companyNames = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getCompanyById(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Companies/GetCompanyByID/${id}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getCompanyFinancing(page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Companies/GetCompanyFinancing/${page}/${size}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    addCompanyFinancing(financing) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action =
              financing.id > 0
                ? "UpdateCompanyFinancing"
                : "AddCompanyFinancing";
            client
              .post(self.$base_ApiK_Url + `Companies/${action}/`, financing)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    approveCompanyFinancing(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Companies/ApproveCompanyFinancing/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    removeCompanyFinancing(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Companies/RemoveCompanyFinancing`,
                ids
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getFinancingThreshHold(page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Companies/GetFinancingThreshHold/${page}/${size}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    saveFinancingThreshHold(thresh) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action =
              thresh.id > 0
                ? "UpdateFinancingThreshHold"
                : "AddFinancingThreshHold";
            client
              .post(self.$base_ApiK_Url + `Companies/${action}`, thresh)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    deleteFinancingThreshHold(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Companies/DeleteFinancingThreshHold/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    findFinancingThreshHold(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Companies/FindFinancingThreshHold/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    findCompanyFinancingByID(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Companies/FindCompanyFinancingByID/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },

    getCountryCustomerTypes(countryId,senderCustomerType) {
      if (senderCustomerType == "") {
        senderCustomerType = "company";
      }
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  "Utility/GetCountryCustomerTypes/" +
                  countryId +
                  "/" +
                  senderCustomerType
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    createCountryCustomerType(countryServiceData) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Utility/CreateCountryCustomerType`,
                countryServiceData
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteCountryCustomerType(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Utility/DeleteCountryCustomerType/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    //TRANSACTIONS
    getCountriesServices(countryId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  "Transactions/GetCountryServices/" +
                  countryId
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    preApproveTransactions(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + "Transactions/PreApproveTransactions/",
                ids
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getPrincipalServices(principalId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/GetPrincipalServices/${principalId}`
              )
              .then((response) => {
                self.countryServices = response.data;
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getSenderAmount(currencyConversion) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Transactions/GetSenderAmount`,
                currencyConversion
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getReceiverAmount(currencyConversion) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Transactions/GetReceiverAmount`,
                currencyConversion
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getComplianceAmountLimit(countryID) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/GetComplianceAmountLimit/${countryID}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getCountryTransactionServices(countryID) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Utility/GetCountryServices/${countryID}`
              )
              .then((response) => {
                // alert("Services: "+response.data);
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getBridgeActivePayingPartner(body) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + "Transactions/GetBridgeServiceProvider/",
                body
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    addTransaction(transaction) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + "Transactions/AddTransaction/",
                transaction
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTransactionRules(page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/GetTransactionRules/${page}/${size}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTransactions(search) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + "Transactions/GetTransactions/",
                search
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    GetTransactionReceipt(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + "Transactions/GetTransactionReceipt/" + id
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    GetDeclarationForm(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  "Transactions/GetDeclarationDocument/" +
                  id
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    ///GCC REMIT
    DownloadGCCCashTransaction(search) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  "Transactions/DownloadGCCCashTransaction/",
                search
              )
              .then((response) => {
                resolve(response.data);
                // alert("response text: "+JSON.stringify(response.data)+" response data: "+response.data )    //comment after test
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    ///CASHEXPRESS(Al ansari) added by mbuvi
    downloadCashXpressTransactions(search) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  "Transactions/DownloadCashExpressTransactions/",
                search
              )
              .then((response) => {
                resolve(response.data);
                // alert("response text: "+JSON.stringify(response.data)+" response data: "+response.data )    //comment after test
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    ///added by mbuvi
    downloadUremitTransactions(search) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  "Transactions/DownloadUremitTransactions/",
                search
              )
              .then((response) => {
                resolve(response.data);
                // alert("response text: "+JSON.stringify(response.data)+" response data: "+response.data ) //comment after test
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getDailyTransactions() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/GetDailyTransactions`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getWeeklyTransactions() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/GetWeeklyTransactions`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getMonthlyTransactions() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/GetMonthlyTransactions`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getYearlyTransactions() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/GetYearlyTransactions`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getDailyUserRegistrations() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/GetDailyUserRegistrations`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getWeeklyUserRegistrations() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/GetWeeklyUserRegistrations`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getMonthlyUserRegistrations() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/GetMonthlyUserRegistrations`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getYearlyUserRegistrations() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(`${self.$base_ApiK_Url}Reports/GetYearlyUserRegistrations`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => reject(err));
      });
    },
    getTransfastCountries() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Transactions/GetTransfastCountries")
              .then((response) => {
                self.countries = response.data;

                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTransfastStates(countryCode) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  "Transactions/GetTransfastStates/" +
                  countryCode
              )
              .then((response) => {
                self.transfastStates = response.data;

                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTransfastCities(countryCode, stateId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/GetTransfastCities/${countryCode}/${stateId}`
              )
              .then((response) => {
                self.transfastCities = response.data;

                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTransfastReceiverIdType(countryCode) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  "Transactions/GetTransfastReceiverIdType/" +
                  countryCode
              )
              .then((response) => {
                self.transfastReceiverIdTypes = response.data;

                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTransfastRemittanceReasons(countryCode) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  "Transactions/GetTransfastRemittanceReasons/" +
                  countryCode
              )
              .then((response) => {
                self.transfastRemittanceReasons = response.data;

                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTransfastReceiverOccupations() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  "Transactions/GetTransfastReceiverOccupations"
              )
              .then((response) => {
                self.transfastReceiverOccupations = response.data;

                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTransfastPaymentRequest(tfPin) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/GetTransfastPaymentRequest/${tfPin}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    updateTransfastReceiverInfo(receiverInfo) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  "Transactions/UpdateTransfastReceiverInfo",
                receiverInfo
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    updateTransactionReceiverInfo(receiverInfo) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  "Transactions/UpdateTransactionReceiverInfo",
                receiverInfo
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    payOutTransaction(id) {
      let self = this;
      console.log("paying out: ", id);
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Transactions/PayOutTransaction/${id}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    cancelTransaction(transaction) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Transactions/CancelTransaction/`,
                transaction
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    holdTransaction(transaction) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Transactions/HoldTransaction/`,
                transaction
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    releaseTransaction(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Transactions/ReleaseTransaction/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    unCancelTransaction(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Transactions/UnCancelTransaction/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    reverseTransaction(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Transactions/ReverseTransaction/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    pushCashToBridge(referenceNumber) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/CashToBridge/${referenceNumber}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    findTransactionByID(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Transactions/FindTransactionByID/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    //SYSTEM CATEGORIES
    savePaymentInfo(model) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Transactions/UpdateSenderOnlinePayment`,
                model
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTransfastInvoiceStatus(tfPin) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/GetTransfastInvoiceStatus/${tfPin}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    payoutTransfastTransaction(tfPin) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  `Transactions/PayoutTransfastInvoice/${tfPin}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    reverseTransfastTransaction(tfPin) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .delete(
                self.$base_ApiK_Url +
                  `Transactions/ReverseTransfastPayout/${tfPin}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    findTransfastTransaction(referenceNumber) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/FindTransfastTransactionByRefNumber/${referenceNumber}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getInvoiceNumber(transactionId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/GetNextInvoiceNumber/${transactionId}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    saveGeneralLedgerAccount(account) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action =
              account.id > 0
                ? "UpdateGeneralLedgerAccount"
                : "AddGeneralLedgerAccount";
            client
              .post(self.$base_ApiK_Url + `Transactions/${action}/`, account)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteGeneralLedgerAccount(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Transactions/DeleteGeneralLedgerAccount`,
                ids
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    approveGeneralLedgerAccount(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/ApproveGeneralLedgerAccount/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    findGeneralLedgerAccount(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/FindGeneralLedgerAccount/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getGeneralLedgerAccounts(page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/GetGeneralLedgerAccounts/${page}/${size}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getAllGeneralLedgerAccounts() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Transactions/GetAllGeneralLedgerAccounts`
              )
              .then((response) => {
                self.ledgerAccounts = response.data;
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    addLedgerEntry(entry) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_ApiK_Url + `Transactions/AddLedgerEntry`, entry)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getLedgerEntries(search) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Transactions/GetLedgerEntries`,
                search
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    //SETTINGS
    getExchangeRates(fromdate, todate) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Settings/GetExchangeRates/${fromdate}/${todate}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getExchangeRateBulkUploads(id, page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `ExchangeRatesBulkUploads/GetExchangeRateBulkUploads/${id}/${page}/${size}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getExchangeRateFileUploads(page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `ExchangeRatesBulkUploads/ExchangeRateFileUploads/${page}/${size}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getSmallWorldReport() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Utility/getSmallWorlCommision`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTransactionsReport() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Reports/gettransactionsreport`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getWebAppReport(fromdate, todate) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Reports/getWebAppReport/${fromdate}/${todate}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getIncompleteTransactionsReport(fromdate, todate) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Reports/getIncompleteTransactionsReport/${fromdate}/${todate}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getPendingTransactionsReport(size, referenceNumber) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Reports/getPendingTransactionsReport/${size}/${referenceNumber}`
              )
              .then((response) => {
                resolve((self.users = response.data));
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getPendingTransactions() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Transactions/getPendingTransactions`)
              .then((response) => {
                resolve((self.users = response.data));
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getUserLogsReport(size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Reports/GetUserLogs`)
              .then((response) => {
                resolve((self.users = response.data.items));
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getUserKYCAttemptsReport(size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Reports/GetUserKYCAttemptsReport`)
              .then((response) => {
                resolve((self.users = response.data.items));
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    findExchangeRateById(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Settings/FindExchangeRateById/${id}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    findBPSById(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `BPS/getBPSById/${id}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    findBulkExchangeRateById(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `ExchangeRatesBulkUploads/FindExchangeRateById/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    uploadExchangeRate(exchangeRate) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeaderForMultipart()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  `ExchangeRatesBulkUploads/UploadExchangeRates`,
                exchangeRate
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    authorizeExchangeRateBulkUpload(exchangeRate) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeaderForMultipart()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  `ExchangeRatesBulkUploads/AuthorizeExchangeRateBulkUploads`,
                exchangeRate
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    addExchangeRate(exchangeRate) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            let action =
              exchangeRate.id > 0 ? "UpdateExchangeRate" : "AddExchangeRate";
            client
              .post(self.$base_ApiK_Url + `Settings/${action}`, exchangeRate)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    addBPSMarkUp(bps) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            let action = bps.id > 0 ? "UpdateBPS" : "addBPS";
            client
              .post(self.$base_ApiK_Url + `BPS/${action}`, bps)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err.response.data.errors);
                reject(err.response.data.errors);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getBPSMarkUp(runningFrom, runningTo) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            let url = "";
            if (runningFrom && runningTo) {
              url = `BPS/getBPSMarkUps?runningFrom=${runningFrom}&runningTo=${runningTo}`;
            } else {
              url = `BPS/getBPSMarkUps`;
            }
            client
              .get(self.$base_ApiK_Url + `${url}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err.response.data.errors);
                reject(err.response.data.errors);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    addBankDetails(bankDetails) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            let action = "AddBankDetails"; //bankDetails.bankcode > 0 ? `UpdateBankDetails` : `AddBankDeatils`;
            client
              .post(self.$base_ApiK_Url + `Settings/${action}`, bankDetails)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    deactivateExchangeRate(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .delete(
                self.$base_ApiK_Url + `Settings/DeactivateExchangeRate/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    deactivateBPS(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_ApiK_Url + `BPS/deactivateBPS/${id}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    deactivateExchangeRates(exrateIds) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Settings/DeactivateExchangeRates`,
                exrateIds
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    addMobileMoneyProvider(provider) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action =
              provider.id > 0
                ? "UpdateMobileMoneyProvider"
                : "AddMobileMoneyProvider";
            client
              .post(self.$base_ApiK_Url + `Settings/${action}`, provider)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    addSMSProvider(provider) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action =
              provider.id > 0 ? "UpdateSMSProvider" : "AddSMSProvider";
            client
              .post(self.$base_ApiK_Url + `Settings/${action}`, provider)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    setActiveSMSProvider(providerId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  `Settings/SetActiveSMSProvider/` +
                  providerId
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getSMSProviders(companyId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Settings/GetSMSProviders/${companyId}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteSMSProvider(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_ApiK_Url + "Settings/DeleteSMSProvider", ids)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    AddRelationships(relation) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action = relation.id > 0 ? "UpdateRelation" : "AddRelation";
            client
              .post(self.$base_ApiK_Url + `Settings/${action}`, relation)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getRelationships(companyId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Settings/GetRelations/${companyId}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteRelationships(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_ApiK_Url + "Settings/DeleteRelations", ids)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    addCollectionMode(provider) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action =
              provider.id > 0 ? "UpdateCollectionModes" : "AddCollectionModes";
            client
              .post(self.$base_ApiK_Url + `Settings/${action}`, provider)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getCollectionModes(companyId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `Settings/GetCollectionModes/${companyId}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteCollectionMode(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_ApiK_Url + "Settings/DeleteCollectionModes", ids)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    addDocumentType(provider) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action =
              provider.id > 0 ? "UpdateDocumentType" : "AddDocumentType";
            client
              .post(self.$base_ApiK_Url + `Settings/${action}`, provider)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getMobileMoneyProviders(page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Settings/GetMobileMoneyProviders/${page}/${size}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteMobileMoneyProvider(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + "Settings/DeleteMobileMoneyProvider",
                ids
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getAllDocumentTypes(page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Settings/GetDocumentTypes/${page}/${size}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteDocumentTypes(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_ApiK_Url + "Settings/DeleteDocumentTypes", ids)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTariffs(page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Settings/GetTariffs/${page}/${size}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTaxes(page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Settings/GetTaxes/${page}/${size}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    saveTariff(tariff) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action = tariff.id > 0 ? "UpdateTariff" : "AddTariff";
            client
              .post(self.$base_ApiK_Url + `Settings/${action}`, tariff)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getPreapproveTransactions(page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/GetPreapproveTransactions/${page}/${size}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    sendAuthorizationCode(data) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action = "AuthorizeTransactionOTP";
            client
              .post(self.$base_ApiK_Url + `Transactions/${action}`, data)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    authorizeTransactions(data) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action = "AuthorizeTransaction";
            client
              .post(self.$base_ApiK_Url + `Transactions/${action}`, data)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    updateTransactionAuthorization(transactionAuthorization) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action = "UpdateTransactionAuthorization";
            client
              .post(
                self.$base_ApiK_Url + `transactions/${action}`,
                transactionAuthorization
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    saveTax(tax) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action = tax.id > 0 ? "UpdateTax" : "AddTax";
            client
              .post(self.$base_ApiK_Url + `Settings/${action}`, tax)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteTariffs(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_ApiK_Url + "Settings/DeleteTariffs/", ids)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteTaxes(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_ApiK_Url + "Settings/DeleteTaxes/", ids)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    findTariffByID(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Settings/FindTariffByID/${id}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    findTaxByID(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Settings/FindTaxByID/${id}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getCompanyPartnerTransaction(page, size) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Settings/GetCompanyPartnerTransaction/${page}/${size}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    saveCompanyPartnerTransaction(companyPartnerTransaction) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action =
              companyPartnerTransaction.id > 0
                ? "UpdateCompanyPartnerTransaction"
                : "AddCompanyPartnerTransaction";
            client
              .post(
                self.$base_ApiK_Url + `Settings/${action}`,
                companyPartnerTransaction
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteCompanyPartnerTransactions(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url +
                  "Settings/DeleteCompanyPartnerTransactions",
                ids
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    //TRANSACTION RULES
    saveTransactionRule(transactionRule) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            var action =
              transactionRule.id > 0
                ? "UpdateTransactionRule"
                : "CreateTransactionRule";
            client
              .post(
                self.$base_ApiK_Url + `Transactions/${action}`,
                transactionRule
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    findTransactionRuleByID(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Transactions/FindTransactionRuleByID/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteTransactionRules(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + "Transactions/DeleteTransactionRules",
                ids
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getAmountInWords(amountInWordsRequest) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Utility/AmountInWords`,
                amountInWordsRequest
              )
              .then((response) => {
                resolve(response.data);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getUserNameById(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url + `SLAAuthorization/GetUserNameById/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    //USERS
    getUserName() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `SLAAuthorization/GetUserName`)
              .then((response) => {
                self.loggedInUser = response.data;
                resolve(response.data);
              })
              .catch((err) => {
                self.loggedInUser = "Guest";
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    //CUSTOMERS
    getTransactionCustomers(docTypeId, docNumber) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Customers/GetTransactionCustomers/${docTypeId}/${docNumber}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getCustomersByEmail(emailAddress) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Customers/GetCustomersByEmail?emailAdddress=${emailAddress}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getSupportedBanks(query) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Utility/GetSupportedBanksBranches?branchName=${query}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getBanksBySwiftCodeAsync(countryId, swiftCode) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Utility/GetBanksBySwiftCode/${countryId}/${swiftCode}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    //REPORTS
    getDashboardTransactions() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Reports/GetTransactions/`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getAccountings() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Reports/GetAccountings/`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    //SYSTEM LOGS
    getSystemLogs(searchModel) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Settings/GetSystemLogs/`,
                searchModel
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    //SYSTEM CATEGORIES
    saveSystemCategory(model) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            let action =
              model.id > 0 ? "UpdateSystemCategory" : "AddSystemCategory";
            client
              .post(self.$base_ApiK_Url + `Settings/${action}/`, model)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteSystemCategory(ids) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_ApiK_Url + `Settings/DeleteSystemCategory/`, ids)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getSystemCategory(searchModel) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Settings/GetSystemCategory`,
                searchModel
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    findSystemCategory(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Settings/FindSystemCategory/${id}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getCategoryTypes(categoryContext) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  `Settings/GetCategoryTypes/${categoryContext}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    //OFAC
    complianceCheck(ep, firstName, middleName, lastName) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            let url = `Utility/GetPEPSResult/${firstName} ${middleName} ${lastName}`;

            client
              .get(self.$base_ApiK_Url + url)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    //XOOM
    xoomDisbursement(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_Xoom_Url + `CashPickUpTransfer/Disbursement/${id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    xoomDisbursementFailure(model) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_Xoom_Url + `CashPickUpTransfer/DisbursementFailure`,
                model
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    xoomDisbursementInfo(model) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_Xoom_Url + `CashPickUpTransfer/DisbursementInfo`,
                model
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    xoomLookUp(model) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_Xoom_Url + `CashPickUpTransfer/LookUp`, model)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    xoomUnDisbursement(model) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_Xoom_Url + `CashPickUpTransfer/UnDisbursement`,
                model
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getXoomRecipientDocument(countryCode) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_Xoom_Url +
                  `Utilities/GetRecipientDocument?countryCode=${countryCode}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getXoomRecipientDocumentCountry(countryCode, documentType) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_Xoom_Url +
                  `Utilities/GetRecipientDocumentCountry?countryCode=${countryCode}&documentType=${documentType}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

		xoomUpdateReceiverInfo(model) {
			let self = this;
			return new Promise(function (resolve, reject) {
				self
					.setAuthHeader()
					.then((client) => {
						client
							.post(
								self.$base_Xoom_Url + `CashPickUpTransfer/UpdateReceiverInfo`,
								model
							)
							.then((response) => {
								resolve(response.data);
							})
							.catch((err) => {
								console.log(err);
								reject(err);
							});
					})
					.catch((err) => {
						console.log(err);
						reject(err);
					});
			});
		},
		getxoomCashPaidMisMatch(){
			let self = this;
			return new Promise(function (resolve, reject) {
				self
					.setAuthHeader()
					.then((client) => {
						client
							.get(
								self.$base_ApiK_Url + `Reports/xoomCashPaidMisMatch`
							)
							.then((response) => {
								resolve(response.data);
							})
							.catch((err) => {
								console.log(err);
								reject(err);
							});
					})
					.catch((err) => {
						console.log(err);
						reject(err);
					});
			});
		},

    //SMALL WORLD
    smallWorldDisburse(mtn) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            console.log(
              "pulling from: ",
              `${self.$base_SW_Url}SmallWorld/UpdatePartner?mtn=${mtn}`
            );
            client
              .get(`${self.$base_SW_Url}SmallWorld/UpdatePartner?mtn=${mtn}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    cancelSmallWorldInvoice(vm) {
      let self = this;
      let content = {
        referenceNumber: vm.referenceNumber,
        cancelCategoryName: vm.holdCategoryName,
        cancelReason: vm.holdReason,
      };
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(`${self.$base_SW_Url}SmallWorld/CancelInvoice`, content)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    findInvoiceByTfPin(tfPin) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Transactions/FindTransfastInvoiceByTfPin/${tfPin}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getUremitTransaction(transactionReference) {
      // alert("Ref: "+transactionReference)
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Transactions/GetUremitTransaction/${transactionReference}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    formatDate(datetime) {
      if (datetime === "null" || datetime === null || datetime === "") {
        return "";
      } else {
        let date = moment.parseZone(String(datetime)).format("DD/MM/YYYY");
        return date;
      }
    },
    formatPrice(value) {
      // let val = (value/1).toFixed(2).replace('.', ',')
      //   return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      var formatter = new Intl.NumberFormat("en-US", {
        //style: 'currency',
        //currency: 'KES',
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },
    formatShortDate(datetime) {
      let date = moment(String(datetime)).format("DD/MM/YYYY  hh:mm:ss");
      //new Date(datetime).toJSON().slice(0,10)
      return date;
    },

    uploadIndividualKYCDocs(IdFileData) {
      let self = this;

      //alert("payload: "+IdFileData)

      return new Promise(function (resolve, reject) {
        self
          .setAuthHeaderForMultipart()
          .then((client) => {
            client
              .post(
                `${self.$base_ApiK_Url}Customers/SaveIndividualKYCDocuments`,
                IdFileData
              )
              .then((response) => {
                resolve(response.data);
                //alert("results..."+ response.data)
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    async getCompanyDetails(companyId) {
      // alert("Ref: "+transactionReference)
      //  let self = this;
      //  return new Promise(function (resolve, reject) {
      //    self
      //      .setAuthHeader()
      //      .then((client) => {
      //        client
      //          .get(`${self.$base_ApiK_Url}Companies/PullCompanyDetails/${companyId}`)
      //          .then((response) => {
      //           resolve(response.data);
      //           this.companyDetails = response.data;
      //         })
      //          .catch((err) => {
      //            console.log(err);
      //            reject(err);
      //          });
      //      })
      //      .catch((err) => {
      //        console.log(err);
      //        reject(err);
      //      });
      //  });

      let self = this;
      this.setAuthHeader();
      var response = await axios.get(
        `${self.$base_ApiK_Url}Companies/PullCompanyDetails/${companyId}`
      );
      return response.data;
    },

    //added by mbuvi
    uploadCustomerID(IdFileData) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeaderForMultipart()
          .then((client) => {
            client
              .post(
                `${self.$base_ApiK_Url}Utility/UploadCustomerID`,
                IdFileData
              )
              .then((response) => {
                resolve(response.data);
                //alert("results..."+ response.data)
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    //added by mbuvi
    editUserKyc(datain) {
      let self = this;
      var editedKycProfile = Object.assign(datain);
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `SLAAuthorization/UpdateUserKyc`,
                editedKycProfile
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    async GetCompaniesList() {
      let self = this;
      this.setAuthHeader();
      var response = await axios.get(
        self.$base_ApiK_Url + "Companies/GetCompanyCustomer"
      );
      return response.data;
    },

    CreateDirector(userdatain) {
      let self = this;
      var directorProfile = Object.assign(userdatain);
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Customers/CreateCompanyDirector`,
                directorProfile
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    UpdateCompanyDirector(userdatain) {
      let self = this;
      var directorProfile = Object.assign(userdatain);
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Customers/UpdateCompanyDirector`,
                directorProfile
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    deleteCompanyDirector(Id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Customers/DeleteCompanyDirector/${Id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getCompanyDirectors(CompanyId, Id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                `${self.$base_ApiK_Url}Customers/GetCompanyDirectors/${CompanyId}/${Id}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    editKycPhonenumber(datain) {
      let self = this;
      var editedKycProfile = Object.assign(datain);
      const userId = editedKycProfile.userID;
      const phoneNumber = editedKycProfile.phoneNumber;
      // alert("Id: "+userId+" phone: "+phoneNumber)
      // alert("submitted data: "+JSON.stringify(editedKycProfile) )
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$baseUrl +
                  `users/UpdateUserKYCPhoneNo/${userId}/${phoneNumber}`
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    saveInfoRequest(request) {
      let self = this;
      this.setAuthHeader()
        .then((client) => {
          client
            .post(
              self.$base_ApiK_Url + `SLAAuthorization/SaveInfoRequests`,
              request
            )
            .then((result) => {
              resolve(result.data);
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => console.log(error));
    },
    getInfoRequests(customerId) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(
                self.$base_ApiK_Url +
                  "SLAAuthorization/GetInfoRequests/" +
                  customerId
              )
              .then((response) => {
                self.userPemissions = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },

    async GetDirectorsList() {
      let self = this;
      this.setAuthHeader();
      var response = await axios.get(
        self.$base_ApiK_Url + "Companies/GetCompanyDirectors"
      );
      return response.data;
    },

    //added by mbuvi
    CreateCountryService(countryServiceData) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(
                self.$base_ApiK_Url + `Utility/CreateCountryServices`,
                countryServiceData
              )
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getAllCountryTransactionServices() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + `Utility/GetCountryServices/0`)
              .then((response) => {
                // alert("Services: "+response.data);
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    DeleteCountryServices(id) {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .post(self.$base_ApiK_Url + `Utility/DeleteCountryServices/${id}`)
              .then((response) => {
                resolve(response.data);
              })
              .catch((err) => {
                console.log(err);
                reject(err);
              });
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    GetCountryCurrencies() {
      let self = this;
      return new Promise(function (resolve, reject) {
        self
          .setAuthHeader()
          .then((client) => {
            client
              .get(self.$base_ApiK_Url + "Settings/GetCountryCurrencies/")
              .then((response) => {
                self.currencies = response.data;
                resolve(response.data);
              })
              .catch((err) => reject(err));
          })
          .catch((err) => console.log(err));
      });
    },
  }, //end export default, no function outside this brace
};
